// extracted by mini-css-extract-plugin
export default {"container":"QuantityInput_container__VQUa5","label":"QuantityInput_label__Gm63x","arrow":"QuantityInput_arrow__ghuGK","value":"QuantityInput_value__RQZV9"};